import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Label, Input } from "reactstrap";
import { updateFilters } from "../../../state/filters/actions";

export function Search(props) {
  const { filters, updateFiltersAction } = props;

  return (
    <div className="search-filter-container d-flex justify-content-start py-2">
      <div role="search">
        <Label for="title-search" className="d-none">
          Search
        </Label>
        <Input
          id="title-search"
          onChange={(e) => {
            updateFiltersAction({ ...filters, text: e.target.value });
          }}
          placeholder="Search Events..."
          name="filterByText"
          value={filters.text}
        />
      </div>
    </div>
  );
}

Search.propTypes = {
  filters: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,
  updateFiltersAction: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  filters: state.filters.filters
});

const mapDispatchToProps = {
  updateFiltersAction: updateFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
